export default function FormControlLabel() {
  return {
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          fontSize: '0.75rem',
          '& .MuiTypography-root': {
            fontSize: 'unset'
          }
        }
      }
    }
  };
}
